<template>
  <th v-if="isHeader">
    <!--  -->
    Actions
  </th>
  <td v-else>
    <div>
      <dropdown v-if="$route.meta.isAdmin">
        <!-- <dropdown-action icon="chart" @click="onClickDownloadInsights">Download Insights</dropdown-action> -->
        <dropdown-action icon="edit" @click="onClickEdit" v-if="userCanAdd"
          >Edit {{ type }}</dropdown-action
        >
        <dropdown-action icon="preview" @click="onClickPreview"
          >Preview {{ type }}</dropdown-action
        >
        <dropdown-action
          icon="tick"
          @click="onClickPublish"
          v-if="userCanPublish && rowData.status == 'pending'"
          >Publish {{ type }}</dropdown-action
        >
        <dropdown-action
          icon="cross"
          @click="onClickReject"
          v-if="userCanPublish && rowData.status == 'pending'"
          >Reject {{ type }}</dropdown-action
        >
        <dropdown-action
          icon="delete"
          @click="onClickDelete"
          v-if="userCanPublish"
          >Delete {{ type }}</dropdown-action
        >
      </dropdown>

      <div v-else>
        <base-tooltip
          :text="
            rowData.user_favourite ? 'Remove from Starred' : 'Add to Starred'
          "
        >
          <tr-action
            icon="star"
            label="Star"
            @click="onClickStar"
            :active="rowData.user_favourite"
          ></tr-action>
        </base-tooltip>
        <base-tooltip text="Download">
          <tr-action
            icon="download"
            label="Download"
            @click="onClickDownload"
          ></tr-action>
        </base-tooltip>
      </div>
    </div>
    <modal
      v-if="rejectModalOpen"
      class="ta-center"
      show-close-button
      @close="rejectModalOpen = false"
    >
      <h1 slot="header">Reason for Rejection</h1>
      <form method="post" action v-on:submit.prevent="rejectArticle">
        <form-field
          type="textarea"
          placeholder="Please specify a reason for rejection"
          v-model="rejectionReason"
          required
        />
        <base-button type="submit" :primary="true">Submit Reason</base-button>
      </form>
    </modal>
  </td>
</template>

<script>
import Dropdown from './../Dropdown';
import DropdownAction from './../DropdownAction';

import TrAction from './../TableRowAction';

import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin';
import UserHasPermission from '@/mixins/UserHasPermission';
export default {
  name: 'document-actions',

  props: {
    rowData: Object,
    id: [String, Number],
    routePath: String,
    type: {
      type: String,
      default: 'Article',
    },
    previewRoute: {
      type: String,
      default: 'NewsRead',
    },
    deleteAction: {
      type: String,
      default: 'News/delete',
    },
    publishAction: {
      type: String,
      default: 'News/approve',
    },
    rejectAction: {
      type: String,
      default: 'News/reject',
    },
  },

  computed: {
    userCanAdd() {
      return this.userHasPermission('add_edit_news');
    },
    userCanPublish() {
      return this.userHasPermission('publish_news');
    },
  },

  methods: {
    onClickEdit() {
      this.$router.push({
        name: this.routePath,
        params: { id: this.id },
      });
    },
    onClickPreview() {
      const route = this.$router.resolve({
        name: this.previewRoute,
        params: { id: this.id },
      });
      window.open(route.href, '_blank');
    },

    onClickPublish() {
      const vm = this;
      this.$store.dispatch('createDialog', {
        confirm: () => {
          this.$store.dispatch(this.publishAction, this.id).then(resp => {
            vm.$store.dispatch(
              'notifications/create',
              {
                body: `The ${this.type} was published`,
                type: 'success',
              },
              { root: true }
            );
            setTimeout(() => {
              vm.$store.dispatch(
                `${this.type == 'news' ? 'News' : 'Events'}/list`
              );
            }, 1000); //temporary measure for now
          });
        },
      });
    },

    onClickReject() {
      this.rejectModalOpen = true;
      return;
    },

    rejectArticle() {
      const vm = this;
      // do the following, but post the rejection reason along with the id i guess
      this.$store
        .dispatch(this.rejectAction, {
          id: this.id,
          reason: this.rejectionReason,
        })
        .then(resp => {
          this.rejectionReason = '';
          this.rejectModalOpen = false;
          vm.$store.dispatch(
            'notifications/create',
            {
              body: `The ${this.type} was rejected`,
              type: 'success',
            },
            { root: true }
          );

          setTimeout(() => {
            vm.$store.dispatch(
              `${this.type == 'news' ? 'News' : 'Events'}/list`
            );
          }, 1000); //temporary measure for now
        });
    },

    onClickStar() {
      if (!this.rowData.user_favourite) {
        this.$store.dispatch('documents/favourite', this.id);
      } else {
        this.$store.dispatch('documents/unfavourite', this.id);
      }

      this.rowData.user_favourite = !this.rowData.user_favourite;
    },

    onClickDelete() {
      this.$store.dispatch('createDialog', {
        confirm: () => {
          this.$store.dispatch(this.deleteAction, this.id);
        },
      });
    },
  },

  data() {
    return {
      rejectionReason: '',
      rejectModalOpen: false,
    };
  },

  components: {
    Dropdown,
    DropdownAction,
    TrAction,
  },

  mixins: [VuetableFieldMixin, UserHasPermission],
};
</script>
